import * as React from 'react';
import {cn} from '../lib/utils';

export type ThinkingProps = React.HTMLAttributes<HTMLDivElement>;

export const Thinking = React.forwardRef<HTMLDivElement, ThinkingProps>(
  ({className, children, ...props}, ref) => (
    <div
      ref={ref}
      role="status"
      className={cn(
        'flex items-center gap-2 text-sm text-muted-foreground',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  ),
);
Thinking.displayName = 'Thinking';

export type ThinkingDotsProps = React.HTMLAttributes<HTMLDivElement>;

export const ThinkingDots = React.forwardRef<HTMLDivElement, ThinkingDotsProps>(
  ({className, ...props}, ref) => (
    <div
      ref={ref}
      className={cn('flex items-center gap-1', className)}
      {...props}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="size-1.5 animate-pulse rounded-full bg-muted-foreground/60"
          style={{animationDelay: `${i * 200}ms`}}
        />
      ))}
    </div>
  ),
);
ThinkingDots.displayName = 'ThinkingDots';

export type ThinkingLabelProps = React.HTMLAttributes<HTMLSpanElement>;

export const ThinkingLabel = React.forwardRef<
  HTMLSpanElement,
  ThinkingLabelProps
>(({className, children = 'Thinking', ...props}, ref) => (
  <span ref={ref} className={cn('text-shimmer', className)} {...props}>
    {children}
  </span>
));
ThinkingLabel.displayName = 'ThinkingLabel';
